import React from 'react';
import { connect } from 'react-redux';
import {
  useHistory, useParams,
} from 'react-router-dom';
import { destroyIsland } from '../../../redux/reducers/islandReducer';

import ModalWrapper from '../../modals/ModalWrapper';

interface Props {
  onConfirmDelete: (id: string) => void;
}

const DeleteIsland = ({ onConfirmDelete }: Props): React.ReactElement => {
  const history = useHistory();
  const { id: islandId }: {id: string} = useParams();

  return (
    <ModalWrapper headerTitle="Delete Island?">
      <div className="delete-island form">
        <div className="form-section form-actions">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="button primary"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={() => {
              onConfirmDelete(islandId);
              history.goBack();
            }}
            className="button primary"
          >
            Delete
          </button>
        </div>

      </div>
    </ModalWrapper>
  );
};

const mapStateToProps = () => ({
  onConfirmDelete: (id: string) => {
    destroyIsland({ id, type: 'islands' });
  },
});

export default connect(mapStateToProps)(DeleteIsland);
